import * as c from '../../../../../constants.jsx';
import GeneticPanelsCardTemplate from "../../../../../components/CockpitCards/GeneticPanelsCardTemplate.jsx";

export default function CancerCard() {

return(
<>

<GeneticPanelsCardTemplate

  panel_url = {`${c.API_URL}/api/cancer`}

  panel_name = { "HEREDITARY CANCER RISKS" }
  panel_subtext = {"A family cancer syndrome is a condition caused by changes in certain genes that are passed down from parents to children and make it more likely for family members to get certain types of cancer. This panel lists and checks various inherited conditions that can raise the risk of specific types of cancer."}

/>

</> 
)}